// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3owvk","disabled":"FileBtn_disabled__2kOlR","warn":"FileBtn_warn__2drS3","fade":"FileBtn_fade__3ZSPj"};